export function createLayerState (name: string, attributes: {[key: string]: string|number}): any {
    return {
        visibility: 'none',
        isLoading: true,
        name,
        ...attributes
    }
}
